// extracted by mini-css-extract-plugin
export var cookiesSection = "fg_K1";
export var cookiesSection__btn = "fg_K4";
export var cookiesSection__link = "fg_K3";
export var cookiesSection__text = "fg_K2";
export var cookiesSection__wrapper = "fg_K0";